export function getIsTruthy(val: string | boolean | undefined | null) {
  if (!val || val === 'null' || val === '0' || val === 'false') {
    return false;
  }
  return true;
}
